export const buttonType = {
  NEXT: 'next',
  BACK: 'back',
  CONFIGURE: 'configure',
  BASKET: 'add_to_basket',
  CLOSE: 'close',
  SKIP: 'skip'
};
